/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../../google/protobuf/struct';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "PromotionRule": {
                    "fields": {
                      "ruleType": {
                        "type": "squareup.solidshop.v2.resources.PromotionRule.RuleType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "preferences": {
                        "type": "google.protobuf.Value",
                        "id": 2,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "RuleType": {
                        "values": {
                          "STORE": 1,
                          "PRODUCT": 2,
                          "SALES_CART_PROMOTION_RULE": 3,
                          "USER_LOGGED_IN": 4
                        }
                      }
                    }
                  },
                  "PromotionAction": {
                    "fields": {
                      "actionType": {
                        "type": "squareup.solidshop.v2.resources.PromotionAction.ActionType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "preferences": {
                        "type": "google.protobuf.Value",
                        "id": 2,
                        "keyType": "string"
                      }
                    },
                    "nested": {
                      "ActionType": {
                        "values": {
                          "PER_ITEM": 1,
                          "FREE_SHIPPING": 2
                        }
                      }
                    }
                  },
                  "Promotion": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "baseCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "promotionRules": {
                        "type": "squareup.solidshop.v2.resources.PromotionRule",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "promotionActions": {
                        "type": "squareup.solidshop.v2.resources.PromotionAction",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "startsAt": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  },
                  "PromotionRetrieved": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "baseCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "promotionRules": {
                        "type": "squareup.solidshop.v2.resources.PromotionRule",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "promotionActions": {
                        "type": "squareup.solidshop.v2.resources.PromotionAction",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "startsAt": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.PromotionRule && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.PromotionRule?.nested?.RuleType && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.PromotionAction && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.PromotionAction?.nested?.ActionType && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.Promotion && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.PromotionRetrieved) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE PromotionRule @ squareup/solidshop/v2/resources/promotion.proto at 12:1
 */
export const PromotionRule = $root.lookupType('squareup.solidshop.v2.resources.PromotionRule');
fixType(PromotionRule);
Builder.createAndAttachToType(PromotionRule);
/**
 * SOURCE RuleType @ squareup/solidshop/v2/resources/promotion.proto at 13:3
 */
PromotionRule.RuleType = $root.lookupEnum('squareup.solidshop.v2.resources.PromotionRule.RuleType').values;
/**
 * SOURCE PromotionAction @ squareup/solidshop/v2/resources/promotion.proto at 61:1
 */
export const PromotionAction = $root.lookupType('squareup.solidshop.v2.resources.PromotionAction');
fixType(PromotionAction);
Builder.createAndAttachToType(PromotionAction);
/**
 * SOURCE ActionType @ squareup/solidshop/v2/resources/promotion.proto at 62:3
 */
PromotionAction.ActionType = $root.lookupEnum('squareup.solidshop.v2.resources.PromotionAction.ActionType').values;
/**
 * SOURCE Promotion @ squareup/solidshop/v2/resources/promotion.proto at 101:1
 */
export const Promotion = $root.lookupType('squareup.solidshop.v2.resources.Promotion');
fixType(Promotion, {
  name: { required: true },
  baseCode: { required: true },
  expiresAt: { required: true },
});
Builder.createAndAttachToType(Promotion);
/**
 * this proto does not require the `expires_at` field,
 * it is exists so promotions without the expiration field set
 * can be returned
 *
 * SOURCE PromotionRetrieved @ squareup/solidshop/v2/resources/promotion.proto at 127:1
 */
export const PromotionRetrieved = $root.lookupType('squareup.solidshop.v2.resources.PromotionRetrieved');
fixType(PromotionRetrieved, {
  name: { required: true },
  baseCode: { required: true },
});
Builder.createAndAttachToType(PromotionRetrieved);
